import React from "react"

import {
  SmartMatchingData,
  SmartMatchingDataPerson,
} from "~/SmartMatching/SmartMatchingContext"
import CollapsibleSection from "./CollapsibleSection"
import {
  isFieldTypeIncluded,
  getFieldScoreByType,
} from "./helpers/fieldScoreResolvers"
import { summarizeMatches } from "./helpers/summarizeMatches"

type Props = {
  smartMatchingData: SmartMatchingDataPerson
  embeddingFields: SmartMatchingData["embeddingFields"]
}

const SkillsSection = ({ smartMatchingData, embeddingFields }: Props) => {
  if (
    !isFieldTypeIncluded(embeddingFields, "NAME", "SKILL") ||
    smartMatchingData.matchedSkills.length === 0
  ) {
    return null
  }

  const score = getFieldScoreByType(
    smartMatchingData,
    embeddingFields,
    "NAME",
    "SKILL",
  )

  return (
    <CollapsibleSection
      title="Skills"
      summary={summarizeMatches(smartMatchingData.matchedSkills)}
      score={score}
    >
      <div>Skills details will go here...</div>
    </CollapsibleSection>
  )
}

export default SkillsSection
